<template>
    <div class="footer__menu">
        <FooterContacts class="footer__menu-contacts-mobile" />
        <template v-for="(item, index) in menuFooter">
            <div
                v-if="!item.hideInFooter"
                :key="item.slug + index"
                :class="['fm__container', {'fm__link--eco': item.isEcoPage}]"
                itemscope
                itemtype="http://schema.org/SiteNavigationElement"
            >
                <div class="relative">
                    <n-link
                        class="fm__link fm__link--main"
                        :to="!item.path ? `/${item.slug}` : item.path"
                        itemprop="url"
                    >
                        <span v-show="!item.isEcoPage">
                            {{ item.title }}
                        </span>
                        <nuxt-img
                            v-show="item.isEcoPage"
                            src="icons/green-vector.svg"
                            alt="eco"
                            class="fm__link--eco"
                            loading="lazy"
                        />
                    </n-link>
                    <span
                        :class="['cheveron-icon', {'active': activeItem.includes(item.slug)}]"
                        @click="onShowMenu(item.slug)"
                    />
                </div>
                <transition
                    name="fade"
                    mode="out-in"
                >
                    <ul
                        v-show="activeItem.includes(item.slug)"
                        class="fm__links"
                    >
                        <template v-for="childItem in item.subMenu">
                            <li :key="childItem.slug">
                                <n-link
                                    v-if="!childItem.isExternal"
                                    class="fm__link"
                                    :to="childItem.path ? childItem.path : `/${item.slug}/${childItem.slug}`"
                                >
                                    {{ childItem.title }}
                                </n-link>
                                <a
                                    v-else
                                    :href="childItem.path"
                                    class="fm__link"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    {{ childItem.title }}
                                </a>
                            </li>
                        </template>
                    </ul>
                </transition>
            </div>
        </template>
        <div class="fm__container">
            <FooterLinks
                v-for="({title, links}, index) in footerLinks"
                :key="`fl__${index}`"
                :title="title"
                :links="links"
                @footer-link-redirect="onRedirectHandler"
            />
        </div>
        <FooterContacts class="footer__menu-contacts-desktop" />
        <FooterAdditional />
        <CallbackModal
            :is-visible="isModalActive"
            @close="isModalActive = false"
        />
    </div>
</template>

<script>
import {defineComponent, ref, watch} from 'vue';
import {useRoute} from '@nuxtjs/composition-api';

import {menuFooter} from '@/core/models/menu/MenuFooter';
import FooterLinks from '@/components/Sections/Footer/FooterLinks.vue';
import FooterContacts from '@/components/Sections/Footer/FooterContacts.vue';
import FooterAdditional from '@/components/Sections/Footer/FooterAdditional.vue';

export default defineComponent({
    name: 'FooterMenu',
    components: {
        FooterLinks,
        FooterContacts,
        FooterAdditional,
        CallbackModal: () => import('@/components/UI-components/Modal/CallbackModal.vue'),
    },
    setup() {
        const route = useRoute();

        const activeItem = ref([]);
        const isModalActive = ref(false);

        function onShowMenu(slug) {
            if (activeItem.value.includes(slug)) {
                activeItem.value = activeItem.value.filter((item) => item !== slug);

                return;
            }

            activeItem.value.push(slug);
        }

        function onRedirectHandler(event, link) {
            if (link.name !== 'callback') {
                return;
            }

            event.preventDefault();
            isModalActive.value = true;
        }

        watch(() => route.value.path, () => {
            activeItem.value = [];
        });

        return {
            menuFooter,
            activeItem,
            isModalActive,
            footerLinks: [
                {
                    title: 'Следить за нами',
                    links: [
                        {
                            name: 'vk',
                            icon: 'icons/social/footer/vk.svg',
                            url: 'https://vk.com/centrinvest',
                        },
                        {
                            name: 'classmates',
                            icon: 'icons/social/footer/classmates.svg',
                            url: 'https://ok.ru/centrinvest.bank',
                        },
                        {
                            name: 'youtube',
                            icon: 'icons/social/footer/youtube.svg',
                            url: 'https://www.youtube.com/user/centrinvest',
                        },
                        {
                            name: 'telegram',
                            icon: 'icons/social/footer/telegram.svg',
                            url: 'https://t.me/centrinvest_bank',
                            label: 'Для частных лиц',
                        },
                        {
                            name: 'telegram-business',
                            icon: 'icons/social/footer/telegram.svg',
                            url: 'https://t.me/centrinvest_business',
                            label: 'Центр-инвест. Бизнес',
                        },
                    ],
                },
                {
                    title: 'Связаться с нами',
                    links: [
                        // TODO: венуть обратный звонок как будет задача
                        // {
                        //     name: 'callback',
                        //     icon: 'icons/social/footer/callback.svg',
                        //     url: '#',
                        //     tooltip: 'Обратный звонок',
                        // },
                        {
                            name: 'feedback',
                            icon: 'icons/social/footer/feedback.svg',
                            url: '/about/contacts',
                            tooltip: 'Обратная связь',
                        },
                        {
                            name: 'vk',
                            icon: 'icons/social/footer/vk.svg',
                            url: 'https://vk.com/im?sel=-29049863',
                        },
                        {
                            name: 'classmates',
                            icon: 'icons/social/footer/classmates.svg',
                            url: 'https://ok.ru/group/52970451894358/messages',
                        },
                        {
                            name: 'internet-reception',
                            icon: 'icons/social/footer/internet-reception.svg',
                            url: 'https://www.centrinvest.ru/cabinet/internet-reception/info',
                            tooltip: 'Интернет приёмная',
                        },
                    ],
                },
            ],
            onRedirectHandler,
            onShowMenu,
        };
    },
});
</script>

<style lang="scss" scoped>
@import '@/assets/styles/common/footer/footer-menu';
</style>
